export default function MySQL_DAYNAME() {
  return (
    <div>
      <h2>MySQL_DAYNAME</h2>    </div>
  );
}